import React from 'react'
import { Box, colors, Paper, Tooltip, Typography } from '@material-ui/core'

import { X as XIcon, Watch as WatchIcon } from 'react-feather'

import constants from 'constants/index'

import useStyles from './styles'

const StageCard = ({ title, subtitle, status, variant = 'status' }) => {
  const isDateVariant = variant === 'date'
  const isOngoing = status === 'ongoing'

  const {
    CHOOSE_STATUS_BOARD_ICON,
    CHOOSE_STATUS_BOARD_COLOR,
    PROGRESS_STATUS_LABELS,
  } = constants.governanceProjectActivity

  const color = CHOOSE_STATUS_BOARD_COLOR[status] || colors.grey[500]

  const classes = useStyles(color, isOngoing)()

  const Icon = isDateVariant
    ? WatchIcon
    : CHOOSE_STATUS_BOARD_ICON[status] || XIcon

  return (
    <Paper
      elevation={isOngoing ? 2 : 0}
      variant={isOngoing ? 'elevation' : 'outlined'}
      className={classes.paper}
    >
      <Box className={classes.comumContainer}>
        <Box className={classes.containerIcon}>
          <Tooltip title={PROGRESS_STATUS_LABELS[status] || 'Não definido'}>
            <Icon
              size={25}
              strokeWidth={2.5}
              className={classes.categoryIcon}
            />
          </Tooltip>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          textAlign="justify"
        >
          <Typography variant="h5">{title}</Typography>
          <Typography variant="body1">{subtitle}</Typography>
        </Box>
      </Box>
    </Paper>
  )
}

export default StageCard
